import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const adminsKeys = {
  all: ['tenant-admins'] as const,
  lists: () => [...adminsKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...adminsKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
};
